import { SignatureDocxData } from '@/models/signatureDocxData.models';
import { SignaturePdfData } from '@/models/signaturePdfData.models';
import http from './http.service';

class SignService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/***";
    }

    async signPdf(model) {
        if (!model) {
            throw Error("Model is required");
        }

        const signResult = await http.post('http://127.0.0.1:5339/api/certificate/signPdf', model)

        return signResult;
    }

    async signDocx(model) {
        if (!model) {
            throw Error("Model is required");
        }

        const signResult = await http.post('http://127.0.0.1:5339/api/certificate/signDocx', model)

        return signResult;
    }

    async signTestPdf() {
        const testFile = await this.getTestPdf();

        if (testFile && testFile.data && testFile.data.base64Content) {
            // TODO: Move local server url to some config file
            const pdfData = new SignaturePdfData({ contents: testFile.data.base64Content });
            const signResult = await this.signPdf(pdfData);

            if (signResult.data && signResult.data.isError === false) {
                testFile.data.content = signResult.data.contents;
            } else {
                throw Error(JSON.stringify(signResult));
            }

            return testFile;
        }
    }

    async signTestDocx() {
        const testFile = await this.getTestDocx();

        if (testFile && testFile.data && testFile.data.base64Content) {
            // TODO: Move local server url to some config file
            const docxData = new SignatureDocxData({ contents: testFile.data.base64Content });
            const signResult = await this.signDocx(docxData);

            if (signResult.data && signResult.data.isError === false) {
                testFile.data.content = signResult.data.contents;
            } else {
                throw Error(JSON.stringify(signResult));
            }

            return testFile;
        }
    }

    async tryParsePdfBookmark(model) {
        if (!model) {
            throw Error("Model is required");
        }

        return (await http.post('http://127.0.0.1:5339/api/certificate/tryParsePdfBookmark', model)).data;
    }

    b64toBlob(b64Data, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    getTestPdf() {
        return http.get(`/api/File/getTestPdf`);
    }

    getTestDocx() {
        return http.get(`/api/File/getTestDocx`);
    }

    getBase64OfAFile(file) {
        return http.get(`/api/File/GetBase64OfAFile?id=${file.id}&type=${file.docTypeCode}&hash=${file.hash}`);
    }
}

export default new SignService();
